import type { ReactNode } from 'react';

export interface ProductNotice {
  id: string;
  /** Text on the pill badge shown under the product title. */
  label: string;
  /** Modal heading. */
  modalTitle: string;
  /** Modal body. */
  content: ReactNode;
}

const noticeSectionTitle =
  'font-customer-text font-semibold text-[18px] leading-7 tracking-tight text-text-primary';

export const PRODUCT_NOTICES: ProductNotice[] = [
  {
    id: 'warranty',
    label: 'Гарантия и возврат',
    modalTitle: 'Гарантия и возврат',
    content: (
      <>
        <div className="flex flex-col gap-1">
          <p className={noticeSectionTitle}>Передумали?</p>
          <p className="m-0">
            Вы можете вернуть товар в течение 7 дней с момента получения, в
            случае, если заводская упаковка не была вскрыта.
          </p>
        </div>
        <div className="flex flex-col gap-1">
          <p className={noticeSectionTitle}>
            Получили товар с заводским браком?
          </p>
          <p className="m-0">
            Мы предоставляем гарантию качества. Если вы обнаружили
            производственный дефект, свяжитесь с нашей службой поддержки — мы
            сообщим адрес сервисного центра для проверки товара.
          </p>
          <p className="m-0">
            Если по результатам диагностики будет подтверждён заводской брак,
            мы:
          </p>
          <ul className="m-0 flex flex-col gap-0.5">
            <li className="flex gap-2 before:shrink-0 before:content-['•']">
              полностью компенсируем стоимость товара или
            </li>
            <li className="flex gap-2 before:shrink-0 before:content-['•']">
              предложим замену (если товар есть в наличии).
            </li>
          </ul>
        </div>
        <p className="m-0">
          Если у вас возникли вопросы по возврату или гарантии, пожалуйста,
          свяжитесь с нашей службой поддержки — мы обязательно поможем.
        </p>
      </>
    ),
  },
  {
    id: 'imported',
    label: 'Товар из-за границы',
    modalTitle: 'Товар из-за границы',
    content: (
      <>
        <p className="m-0">
          Товар отгружается из-за границы. Срок доставки составляет 5–15 рабочих
          дней.
        </p>
        <div className="flex flex-col gap-1">
          <p className="m-0">
            Согласно таможенным правилам, для оформления доставки необходимо:
          </p>
          <ul className="m-0 flex flex-col gap-0.5">
            <li className="flex gap-2 before:shrink-0 before:content-['•']">
              Указать полное ФИО получателя при оформлении заказа;
            </li>
            <li className="flex gap-2 before:shrink-0 before:content-['•']">
              Предоставить паспортные данные и ИНН таможенному брокеру после
              оформления заказа.
            </li>
          </ul>
        </div>
        <p className="m-0">
          После оформления заказа таможенный брокер направит вам email или SMS с
          инструкциями для заполнения необходимых данных.
        </p>
        <p className="m-0">
          При получении заказа паспорт предъявлять не требуется — доставка
          осуществляется в постаматы.
        </p>
      </>
    ),
  },
];
